module.exports = __webpack_public_path__ + "files/individual-presentation-slides.pdf";